import { IonInput } from "@ionic/react"

export default function MagnumInput({onChange, labelPlacement="floating", type="text", ...props}) {
  return <IonInput type={type} labelPlacement={labelPlacement} onIonInput={onChange} {...props} />
}
